import {
  ApolloClient,
  ApolloLink,
  ApolloProvider as BaseApolloProvider,
  from,
  HttpLink,
  InMemoryCache,
} from '@apollo/client'
import { useDispatch, useSelector } from 'react-redux'
import React from 'react'

import { BACKEND_URL } from 'config/constants'
import { mergeDeepRight } from 'ramda'
import { objectOf } from 'prop-types'
import { onError } from '@apollo/client/link/error'
import { useHistory } from 'react-router-dom'

import { SECURITY__AUTH_TOKEN_EXPIRED } from 'core/Security/reducer'
import STORE_NAMESPACES from 'store/namespaces'

const ApolloProvider = ({ children, ...props }) => {
  const { token } = useSelector(state => state[STORE_NAMESPACES.SECURITY])
  const { push } = useHistory()
  const dispatch = useDispatch()

  const authenticationLink = new ApolloLink((operation, forward) => {
    if (token) {
      operation.setContext(({ headers = {} }) => ({
        headers: mergeDeepRight(headers, {
          Authorization: `Bearer ${token}`,
          'X-Requested-With': 'apollo',
        }),
      }))
    }

    return forward(operation)
  })

  const httpLink = new HttpLink({
    uri: `${BACKEND_URL}/graphql`,
  })

  const errorLink = onError(({ networkError }) => {
    if (networkError) {
      if (networkError.statusCode === 401) {
        dispatch({ type: SECURITY__AUTH_TOKEN_EXPIRED, payload: { push } })
      }
    }
  })

  const config = {
    cache: new InMemoryCache(),
    link: from([errorLink, authenticationLink, httpLink]),
  }

  const client = new ApolloClient(config)

  return (
    <BaseApolloProvider {...props} client={client}>
      {children}
    </BaseApolloProvider>
  )
}

ApolloProvider.propTypes = {
  children: objectOf(() => {}).isRequired,
}

export default ApolloProvider
